var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24IcNotificationspending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.4033124,4.49660684 C14.1468416,4.93863286 14,5.45216808 14,6 C14,7.65685425 15.3431458,9 17,9 C17.2948799,9 17.5798229,8.95745537 17.8490257,8.87816951 C17.9603421,9.40391171 18.016,9.95918782 18.016,10.544 L18.016,15.512 L20.032,17.528 L20.032,18.512 L4,18.512 L4,17.528 L6.016,15.512 L6.016,10.544 C6.016,8.97599216 6.40799608,7.62400568 7.192,6.488 C7.992004,5.31999416 9.10399288,4.56000176 10.528,4.208 L10.528,3.512 C10.528,3.09599792 10.6719986,2.74000148 10.96,2.444 C11.2480014,2.14799852 11.5999979,2 12.016,2 C12.4320021,2 12.7879985,2.14799852 13.084,2.444 C13.3800015,2.74000148 13.528,3.09599792 13.528,3.512 L13.528,4.208 C13.8341434,4.28453586 14.1259141,4.38073806 14.4033124,4.49660684 Z M12.016,21.512 C11.4559972,21.512 10.980002,21.3200019 10.588,20.936 C10.195998,20.5519981 10,20.0880027 10,19.544 L14.032,19.544 C14.032,20.0880027 13.832002,20.5519981 13.432,20.936 C13.031998,21.3200019 12.5600027,21.512 12.016,21.512 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2,
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24IcNotificationspending);
export default __webpack_public_path__ + "static/media/24_ic_notificationspending.c2844107.svg";
export { ForwardRef as ReactComponent };